import { DatePipe, NgFor, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { Course } from '@tanzspass/shared';
import { Room } from '@tanzspass/shared';
import { TvScreenService } from '../../services/tv-screen.service';
import { PictureComponent } from '../../shared/picture/picture.component';

@Component({
  selector: 'ts-infosystem-upcomming-courses',
  templateUrl: './infosystem-upcomming-courses.component.html',
  styleUrls: ['./infosystem-upcomming-courses.component.css'],
  imports: [NgIf, NgFor, PictureComponent, DatePipe],
})
export class InfosystemUpcommingCoursesComponent {
  @Input() schoolId: number;
  upcommingCourses: {
    room: Room;
    currentCourse: Course | null;
    nextCourse: Course | null;
  }[] = [];

  constructor(private tvScreenSrv: TvScreenService) {
    // The payload now carries every room's full schedule; this overview panel
    // shows the showInOverview rooms (the filter that used to live server-side)
    // and renders each room's immediate next course (upcomingCourses[0]).
    this.tvScreenSrv.payload$.pipe(takeUntilDestroyed()).subscribe((payload) => {
      this.upcommingCourses = (payload?.roomCourses ?? [])
        .filter((bucket) => bucket.room.showInOverview)
        .map((bucket) => ({
          room: bucket.room,
          currentCourse: bucket.currentCourse,
          nextCourse: bucket.upcomingCourses[0] ?? null,
        }))
        .filter((entry) => entry.currentCourse || entry.nextCourse);
    });
  }
}
